import React from "react";

import { TeamLineupsPlayerInfo } from "@data-types/sport-stats/SportStatsTypes";
// @ts-ignore
import { playerCard } from "@features/offer/shared/statistics/components/team-lineups";
import TeamLineupsStore from "@state/stores/offer/statistics/TeamLineupsStore";
import { observer } from "mobx-react";

export default observer(function TeamLineupsPlayerInfo(props: {
	store: TeamLineupsStore;
	team: string;
	player: TeamLineupsPlayerInfo;
	position: {
		x: number;
		y: number;
	};
}) {
	const playerAssists = Number(
		props.player.statistics?.summary?.assists ?? 0
	);

	const playerName =
		(props.player.captain ? "(c) " : "") +
		(props.player.shortName || props.player.name);

	const playerJerseyBaseClass = "u-icon u-icon--4xlrg u-icon--jersey";

	return (
		<div
			className="card--jersey"
			style={{
				left: `${props.position.x}px`,
				top: `${props.position.y}px`,
			}}
		>
			<div className="card--jersey__thumbnail">
				<i className={`${playerJerseyBaseClass} u-color--core--snow`}>
					{props.team === "home" && (
						<i
							className={`card--jersey__thumbnail__background ${playerJerseyBaseClass} u-color--sent--success`}
						/>
					)}

					{props.team === "away" && (
						<i
							className={`card--jersey__thumbnail__background ${playerJerseyBaseClass} u-color--sent--note`}
						/>
					)}
				</i>

				<div className="card--jersey__thumbnail__number">
					{props.player.jerseyNumber}
				</div>

				<div
					className={
						"card--jersey__thumbnail__tag tag--rating tag--rating--tny" +
						(props.store.isLiveOrHistory
							? " tag--rating--" +
								props.store.colorGradient(
									props.player.rating !== undefined
										? props.player.rating
										: 0
								)
							: " tag--rating--" +
								props.store.colorGradient(
									props.player.avgRating !== undefined
										? props.player.avgRating
										: 0
								))
					}
				>
					{props.store.isLiveOrHistory
						? props.player.rating === 0.0
							? "-"
							: props.player.rating !== undefined
								? Number(props.player.rating) === 10
									? "10"
									: Number(props.player.rating).toFixed(1)
								: "-"
						: props.player.avgRating !== undefined
							? Number(props.player.avgRating) === 10
								? "10"
								: Number(props.player.avgRating).toFixed(1)
							: "-"}
				</div>
			</div>

			<div className="card--jersey__data">
				<div className="card--jersey__data__col">
					<div className="card--jersey__data__box">
						{playerCard(
							props.player.yellowCard,
							props.player.redCard
						)}
					</div>

					<div className="card--jersey__data__box" />

					<div className="card--jersey__data__box">
						{props.player.substitute ? (
							<i className="card--jersey__data__icon u-icon u-icon--tny u-icon--substitute u-color--core--nero" />
						) : null}
					</div>
				</div>

				<div className="card--jersey__data__col">
					<div className="card--jersey__row">
						<div className="card--jersey__data__box">
							{(props.player.goals ?? 0) > 0 && (
								<i className="card--jersey__data__icon u-icon u-icon--tny u-icon--goal u-color--core--nero" />
							)}
						</div>
						<span>
							{(props.player.goals ?? 0) > 1 && (
								<div className="card--jersey__value">
									{props.player.goals}
								</div>
							)}
						</span>
					</div>

					<div className="card--jersey__row">
						<div className="card--jersey__data__box">
							{playerAssists > 0 && (
								<i className="card--jersey__data__icon u-icon u-icon--tny u-icon--assists u-color--core--nero" />
							)}
						</div>
						<span>
							{playerAssists > 1 && (
								<div className="card--jersey__value">
									{playerAssists}
								</div>
							)}
						</span>
					</div>

					<div className="card--jersey__row">
						<div className="card--jersey__data__box">
							{(props.player.ownGoals ?? 0) > 0 && (
								<i className="card--jersey__data__icon u-icon u-icon--tny u-icon--own-goal u-color--core--nero" />
							)}
						</div>
						<span>
							{(props.player.ownGoals ?? 0) > 1 && (
								<div className="card--jersey__value">
									{props.player.ownGoals}
								</div>
							)}
						</span>
					</div>
				</div>
			</div>

			<div className="card--jersey__name">{playerName}</div>
		</div>
	);
});
